import React, { useEffect, useState } from "react";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import { apiRequest } from "services/tenantUserAdminService";

function saveToStorage(key, value) {
  window.localStorage.setItem(key, JSON.stringify(value));
}

export default function AgentAuthCallback() {
  const [status, setStatus] = useState("Processing...");
  const [error, setError] = useState("");
  const [tokens, setTokens] = useState(null);

  useEffect(() => {
    async function handleCallback() {
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const returnedState = params.get("state");
        const storedState = JSON.parse(window.localStorage.getItem("hmrc_oauth_state"));
        if (!code || !returnedState) throw new Error("Missing code or state in callback");
        if (returnedState !== storedState) throw new Error("State mismatch! Possible CSRF.");
        setStatus("Exchanging code for tokens...");
        // Exchange code for tokens via backend proxy (HMRC does not support CORS)
        const data = await apiRequest("/agent-auth/token", {
          method: "POST",
          body: { code },
        });
        setTokens(data);
        saveToStorage("hmrc_tokens", data);
        setStatus("Token exchange successful! You can now use the API tabs.");
      } catch (e) {
        setError(e.message);
        setStatus("Failed");
      }
    }
    handleCallback();
  }, []);

  return (
    <VuiBox p={3} maxWidth={700} mx="auto" display="flex" flexDirection="column" alignItems="stretch">
      <VuiTypography variant="h4" fontWeight="bold" mb={2}>HMRC OAuth Callback</VuiTypography>
      <VuiTypography mb={2}>{status}</VuiTypography>
      {error && <VuiTypography color="error">{error}</VuiTypography>}
      {tokens && (
        <VuiBox mt={2}>
          <VuiTypography variant="h6">Tokens:</VuiTypography>
          <VuiTypography sx={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(tokens, null, 2)}</VuiTypography>
          <VuiButton color="info" onClick={() => window.location.href = "/agent-authorisation"}>Go to Agent Authorisation UI</VuiButton>
        </VuiBox>
      )}
    </VuiBox>
  );
}

